export default {
  en: {
    supplementTypeList: 'Supplement Type List',
    newSupplementType: 'New Supplement Type',
    name: 'Name',
    createSupplementType: 'Create Supplement Type',
    cancel: 'Cancel',
    createSupplementTypeSuccessTitle: 'Success',
    createSupplementTypeSuccessMessage: 'Create supplement type success.'
  },
  th: {
    supplementTypeList: 'ประเภทรายการเพิ่มเติม',
    newSupplementType: 'สร้างประเภทรายการเพิ่มเติม',
    name: 'ชื่อ',
    createSupplementType: 'สร้างประเภทรายการเพิ่มเติม',
    cancel: 'ยกเลิก',
    createSupplementTypeSuccessTitle: 'สำเร็จ',
    createSupplementTypeSuccessMessage: 'สร้างประเภทรายการเพิ่มเติมสำเร็จ'
  }
}
